export const ONE_HOUR_REFRESH = 1000 * 60 * 60;
export const IS_GLOBAL_FILTER_DRAWER_OPEN_KEY = 'is_global_filter_drawer_open';
